(() => {
  const norm = value => String(value || '').trim().toLocaleLowerCase(document.documentElement.lang || 'it');
  const colorKey = value => ({black:'nero',red:'rosso',grey:'grigio',gray:'grigio',orange:'arancione',yellow:'giallo',torquoise:'turchese',turquoise:'turchese'}[norm(value)] || norm(value));
  const initCatalog = async root => {
    if (root.dataset.refineReady || root.dataset.refineLoading) return;
    const form = root.querySelector('[data-moro-refine-form]');
    let grid = root.querySelector('[data-moro-grid]');
    if (!form || !grid) return;
    root.dataset.refineLoading = 'true';
    const filterKeys = ['categoria','colore','taglia','disponibile','prezzo_min','prezzo_max','ordine'];
    const params = new URL(location.href).searchParams;
    const imported = new Map();
    const nativeMap = {'filter.p.product_type':'categoria','filter.v.availability':'disponibile','filter.v.price.gte':'prezzo_min','filter.v.price.lte':'prezzo_max','filter.v.option.color':'colore','filter.v.option.colore':'colore','filter.v.option.colour':'colore','filter.v.option.nero':'colore','filter.v.option.size':'taglia','filter.v.option.taglia':'taglia','filter.v.option.taglie':'taglia'};
    const mappedKeys = [];
    for (const [key,value] of params) {
      if (nativeMap[key] && params.getAll(key).length === 1 && !value.includes(',')) {
        imported.set(nativeMap[key],value);
        mappedKeys.push(key);
      }
    }
    const requestUrl = new URL(location.href);
    requestUrl.searchParams.set('section_id',root.dataset.section);
    requestUrl.searchParams.delete('page');
    mappedKeys.forEach(key=>requestUrl.searchParams.delete(key));
    const readPage = async url => {
      if (url.origin !== location.origin) throw new Error('Invalid catalog origin');
      const response = await fetch(url,{credentials:'same-origin'});
      if (!response.ok) throw new Error('Catalog unavailable');
      const doc = new DOMParser().parseFromString(await response.text(),'text/html');
      const page = doc.querySelector('[data-moro-catalog]');
      if (!page || page.dataset.section !== root.dataset.section) throw new Error('Invalid catalog section');
      return page;
    };
    try {
      let page = root;
      if (mappedKeys.length || Number(params.get('page') || 1) > 1) page = await readPage(requestUrl);
      const items = [...page.querySelector('[data-moro-grid]').children];
      const expected = Number(page.dataset.filtered);
      const seen = new Set();
      let next = page.querySelector('[data-moro-next]')?.getAttribute('href');
      while (next) {
        const url = new URL(next,location.href);
        url.searchParams.set('section_id',root.dataset.section);
        mappedKeys.forEach(key=>url.searchParams.delete(key));
        if (seen.has(url.href)) throw new Error('Repeated catalog page');
        seen.add(url.href);
        page = await readPage(url);
        items.push(...page.querySelector('[data-moro-grid]').children);
        next = page.querySelector('[data-moro-next]')?.getAttribute('href');
      }
      if (items.length !== expected) throw new Error('Incomplete catalog');
      const cards = items.map((el,index)=>{
        const data=el.querySelector('[data-moro-product-data]');
        if (!data) return {el,index,editorial:true};
        const product=JSON.parse(data.textContent);
        const colorIndex=product.options.findIndex(x=>['color','colore','colour','nero'].includes(norm(x)));
        const sizeIndex=product.options.findIndex(x=>['size','taglia','taglie'].includes(norm(x)));
        return {el,index,...product,colorIndex,sizeIndex};
      });
      const products=cards.filter(c=>!c.editorial);
      if (!products.length && !mappedKeys.length) return;
      grid.replaceChildren(...items);
      root.querySelectorAll('.pagination-wrapper,[data-moro-server-empty]').forEach(el=>el.hidden=true);
      const values={type:new Map(),color:new Map(),size:new Map()};
      products.forEach(card=>{
        if(card.type)values.type.set(norm(card.type),card.type);
        card.variants.forEach(variant=>[['color',card.colorIndex],['size',card.sizeIndex]].forEach(([kind,i])=>{
          if(i<0 || !variant.options[i])return;
          const key=kind==='color'?colorKey(variant.options[i]):norm(variant.options[i]);
          values[kind].set(key,kind==='color'?key.charAt(0).toUpperCase()+key.slice(1):variant.options[i]);
        }));
      });
      form.querySelectorAll('[data-moro-options]').forEach(select=>{
        const sizes=['xxs','xs','s','s-m','m','l','l-xl','xl','xxl','2xl','xxxl','3xl'];
        const entries=[...values[select.dataset.moroOptions]].sort((a,b)=>select.dataset.moroOptions==='size' && sizes.includes(a[0]) && sizes.includes(b[0])?sizes.indexOf(a[0])-sizes.indexOf(b[0]):a[1].localeCompare(b[1],'it',{numeric:true}));
        entries.forEach(([value,label])=>select.add(new Option(label,value)));
        if(!entries.length)select.parentElement.hidden=true;
      });
      const count=root.querySelector('[data-moro-count]');
      const toggle=root.querySelector('.moro-filter-toggle');
      const panel=root.querySelector('.moro-filter-panel');
      const hasNativeConstraint=()=>[...new URL(location.href).searchParams.keys()].some(k=>k.startsWith('filter.') && !mappedKeys.includes(k));
      const apply=(updateUrl=true)=>{
        const data=new FormData(form);
        const q=Object.fromEntries(filterKeys.map(k=>[k,data.get(k)||'']));
        const min=q.prezzo_min===''?0:Math.max(0,Number(q.prezzo_min))*100;
        const max=q.prezzo_max===''?Infinity:Math.max(0,Number(q.prezzo_max))*100;
        const active=filterKeys.filter(k=>k!=='ordine' && q[k]).length;
        let matches=0;
        cards.forEach(card=>{
          if(card.editorial){card.el.hidden=Boolean(active);return;}
          const variants=card.variants.filter(v=>(!q.colore || colorKey(v.options[card.colorIndex])===q.colore) && (!q.taglia || norm(v.options[card.sizeIndex])===q.taglia) && (!q.disponibile || v.available===(q.disponibile==='1')) && v.price>=min && v.price<=max);
          const variant=variants.find(v=>v.available)||variants[0];
          const fits=(!q.categoria || norm(card.type)===q.categoria) && Boolean(variant);
          card.matchPrice=variant?.price ?? card.price;
          card.el.querySelectorAll('a[href*="/products/"]').forEach(link=>{
            if(!link.dataset.moroBaseUrl)link.dataset.moroBaseUrl=link.href;
            const url=new URL(link.dataset.moroBaseUrl);
            if(fits && (q.colore || q.taglia))url.searchParams.set('variant',variant.id);
            link.href=url.href;
          });
          const image=card.el.querySelector('.card__media img');
          if(image){
            if(!card.originalImage)card.originalImage={src:image.getAttribute('src'),srcset:image.getAttribute('srcset'),alt:image.getAttribute('alt')};
            const selected=fits && (q.colore || q.taglia) && variant?.image;
            const attrs=selected?{src:variant.image.url,srcset:null,alt:variant.image.alt||card.title}:card.originalImage;
            Object.entries(attrs).forEach(([key,value])=>value===null?image.removeAttribute(key):image.setAttribute(key,value));
            card.el.querySelectorAll('.card__media img').forEach((img,i)=>{if(i)img.hidden=Boolean(selected);});
          }
          card.el.hidden=!fits;
          if(fits)matches++;
        });
        const ordered=[...cards].sort((a,b)=>a.editorial||b.editorial?(a.editorial&&b.editorial?a.index-b.index:a.editorial?1:-1):q.ordine==='price-ascending'?a.matchPrice-b.matchPrice:q.ordine==='price-descending'?b.matchPrice-a.matchPrice:q.ordine==='created-descending'?Number(b.created)-Number(a.created):q.ordine==='title-ascending'?a.title.localeCompare(b.title):a.index-b.index);
        ordered.forEach(card=>grid.append(card.el));
        count.textContent=`${matches} ${matches===1?count.dataset.singular:count.dataset.label}`;
        root.querySelector('[data-moro-no-results]').hidden=matches>0 || (!active && cards.some(c=>c.editorial));
        root.querySelector('[data-moro-filter-count]').textContent=active?`(${active})`:'';
        if(updateUrl){
          const url=new URL(location.href);
          mappedKeys.forEach(k=>url.searchParams.delete(k));
          url.searchParams.delete('page');
          filterKeys.forEach(k=>q[k] && !(k==='ordine' && q[k]==='featured')?url.searchParams.set(k,q[k]):url.searchParams.delete(k));
          history.replaceState(null,'',url);
        }
      };
      const restore=()=>{
        const current=new URL(location.href).searchParams;
        filterKeys.forEach(k=>{
          let value=current.get(k) ?? imported.get(k) ?? (k==='ordine'?'featured':'');
          if(k==='colore')value=colorKey(value);
          else if(k!=='prezzo_min' && k!=='prezzo_max')value=norm(value);
          form.elements[k].value=value;
        });
        apply(false);
      };
      form.addEventListener('submit',e=>{e.preventDefault();apply();});
      form.addEventListener('change',()=>apply());
      let inputTimer;
      form.addEventListener('input',event=>{if(event.target.type==='number'){clearTimeout(inputTimer);inputTimer=setTimeout(()=>apply(),150);}});
      form.addEventListener('reset',()=>{
        imported.clear();
        if(hasNativeConstraint()){
          const url=new URL(location.href);
          [...url.searchParams.keys()].filter(k=>k.startsWith('filter.')||filterKeys.includes(k)||k==='page').forEach(k=>url.searchParams.delete(k));
          location.assign(url);return;
        }
        requestAnimationFrame(()=>apply());
      });
      toggle.addEventListener('click',()=>{panel.hidden=!panel.hidden;toggle.setAttribute('aria-expanded',String(!panel.hidden));});
      root.querySelector('[data-moro-clear]').addEventListener('click',()=>form.reset());
      window.addEventListener('popstate',restore);
      root.dataset.refineReady='true';
      root.querySelector('.moro-refine').hidden=false;
      restore();
    }catch(error){root.dataset.refineError='true';}
    finally{delete root.dataset.refineLoading;}
  };

  const initNavigation = () => {
    document.querySelectorAll('.moro-nav-disclosure').forEach(details => {
      if (details.dataset.bound) return;
      details.dataset.bound='true';
      details.addEventListener('toggle',()=>{if(details.open) document.querySelectorAll('.moro-nav-disclosure[open]').forEach(other=>{if(other!==details)other.open=false;});});
      details.addEventListener('keydown',event=>{if(event.key==='Escape'){details.open=false;details.querySelector('summary').focus();}});
      details.addEventListener('focusout',event=>{if(event.relatedTarget && !details.contains(event.relatedTarget))details.open=false;});
    });
  };
  document.addEventListener('click',event=>document.querySelectorAll('.moro-nav-disclosure[open]').forEach(d=>{if(!d.contains(event.target))d.open=false;}));
  const init = () => {document.querySelectorAll('[data-moro-catalog]').forEach(initCatalog);initNavigation();};
  init();
  document.addEventListener('shopify:section:load',init);
})();
